import React from 'react';

export default function NotFoundScreen() {
  return <div style={{ margin: 'auto', textAlign: 'center', paddingTop: 30 }}>Page Not Found !</div>;
}
